/* global $, Shopify, meta */
(function () {
  const AUTO_TRACKING_SCRIPT_FLAG = '__OGL_AUTO_TRACKING_SCRIPT_LOADED__';
  if (window[AUTO_TRACKING_SCRIPT_FLAG]) {
    window.report_faro({
      file_name: 'assets/auto-tracking.js',
      func_name: 'init',
      desc: 'OGL auto-tracking script already loaded',
      error: 'Skip duplicate initialization'
    });
    return;
  }
  window[AUTO_TRACKING_SCRIPT_FLAG] = true;

  (function () {
    try {
      // 配置默认埋点
      const trackingConfig = [
        // nav
        {
          selector: {
            container: '#t4s-nav-ul',
            item: ['.t4s-menu-item']
          },
          section_name: 'nav'
        },
        // nav icons
        {
          selector: {
            container: '.t4s-site-nav__icons',
            item: ['.t4s-site-nav__icon']
          },
          section_name: 'nav-icon'
        },
        // filter
        {
          selector: {
            container: '.t4s-btn-filter-wrapper',
            item: ['']
          },
          section_name: 'filter'
        },
        // filter sort by
        {
          selector: {
            container: '.t4s-dropdown__sortby',
            item: ['']
          },
          section_name: 'filter-sortby'
        },
        // logo
        {
          selector: {
            container: '.t4s-header__logo',
            item: ['']
          },
          section_name: 'logo'
        },
        // shipping
        {
          selector: {
            container: '.t4s-shipping-list',
            item: ['.t4s-shipping']
          },
          section_name: 'shipping'
        },
        // cookie 弹窗
        {
          selector: {
            container: '.shopify-pc__banner__btns',
            item: ['button']
          },
          section_name: 'cookie-popup'
        },
        // footer
        {
          selector: {
            container: '.t4s-footer-content',
            item: ['li', '.t4s-col-item']
          },
          section_name: 'footer'
        },
        // footer-heading
        {
          selector: {
            container: '.t4s-footer-heading',
            item: ['']
          },
          section_name: 'footer-heading'
        },
        // breadcrumb
        {
          selector: {
            container: '.t4s-pr-breadcrumb',
            item: ['a']
          },
          section_name: 'breadcrumb'
        },
        // custom liquid
        {
          selector: {
            container: '[class*="__custom_liquid_"]', // 使用 :visible:eq(n) 来选择
            item: ['video', '.fabric-column', 'a', 'button'] // 每一项都可能会有很多个，注意使用 :eq(n) 来选择
          },
          section_name: 'custom-liquid'
        },
        // custom html
        {
          selector: {
            container: '[class*="__custom_html_"]',
            item: ['video', 'a', 'button']
          },
          section_name: 'custom-html'
        },
        // background video
        {
          selector: {
            container: '[class*="__background_video_"]',
            item: ['video']
          },
          section_name: 'background-video'
        },
        // collections list
        {
          selector: {
            container: '[class*="__collections_list_"]',
            item: ['.t4s-cat-content']
          },
          section_name: 'collections-list'
        },
        // banner
        {
          selector: {
            container: '.t4s-banner-holder',
            item: ['.t4s-banner-item']
          },
          section_name: 'banner'
        },
        // flickityt4s-wrap 首页面料入口等
        {
          selector: {
            container: '.flickityt4s-wrap',
            item: ['.t4s-collection-item']
          },
          section_name: 'flickityt4s-wrap-collection-item'
        },
        // 德国站语言切换
        {
          selector: {
            container: '.hq-current-language',
            item: ['']
          },
          section_name: 'language-selector'
        },
        // 详情页 fabric
        {
          selector: {
            container: '.mibao_fabric_list',
            item: ['> a', '> span']
          },
          section_name: 'fabric'
        },
        // 详情页 style
        {
          selector: {
            container: '.t4s-swatch__list',
            item: ['[data-swatch-item]']
          },
          section_name: 'style'
        },
        // shop by category
        {
          selector: {
            container: '[class*="_template--"].shop_by_category',
            item: ['.t4s-collection-item']
          },
          section_name: 'shop-by-category'
        },
        // products
        {
          selector: {
            container: '.t4s-products',
            item: ['.t4s-product']
          },
          section_name: 'products'
        },
        // women_list
        {
          selector: {
            container: '.women_list',
            item: ['.t4s-collection-item']
          },
          section_name: 'women-list'
        },
        // influencers_in_ogl
        {
          selector: {
            container: '.influencers_in_ogl',
            item: ['[data-goto--item]']
          },
          section_name: 'influencers-in-ogl'
        },
        // related_searches
        {
          selector: {
            container: '.related_searches',
            item: ['.t4s-feature-columns__content']
          },
          section_name: 'related-searches'
        },
        // site_women_list
        {
          selector: {
            container: '.site_women_list',
            item: ['.t4s-collection-item']
          },
          section_name: 'site-women-list'
        },
        // t4s-announcement-bar
        {
          selector: {
            container: '.t4s-announcement-bar',
            item: ['']
          },
          section_name: 'announcement-bar'
        },
        // data-currency-wrap
        {
          selector: {
            container: '[data-currency-wrap]',
            item: ['']
          },
          section_name: 'currency-wrap'
        },

        // product页面
        // product images
        {
          selector: {
            container: '[data-product-single-media-group]',
            item: ['[data-product-single-media-wrapper]']
          },
          section_name: 'product-images'
        },
        // color、size、style
        {
          selector: {
            container: '.t4s-swatch__list',
            item: ['[data-swatch-item]']
          },
          section_name: 'color-size-style'
        },
        // add to cart
        {
          selector: {
            container: '#main-product .t4s-product-form__submit',
            item: ['']
          },
          section_name: 'add-to-cart'
        },
        // type tabs
        {
          selector: {
            container: '.t4s-type-tabs',
            item: ['.t4s-tab-wrapper']
          },
          section_name: 'type-tabs'
        },
        // size-chart
        {
          selector: {
            container: '.t4s-btn__size-chart',
            item: ['']
          },
          section_name: 'size-chart'
        },
        // what's my size
        {
          selector: {
            container: '#what-my-size-entry',
            item: ['']
          },
          section_name: 'what-my-size'
        },
        // guide_table
        {
          selector: {
            container: '.guide_table',
            item: ['.header span']
          },
          section_name: 'guide-table'
        },
        // mibao_product_descrition_images
        {
          selector: {
            container: '.mibao_product_descrition_images',
            item: ['']
          },
          section_name: 'mibao-product-descrition-images'
        },
        // write a review
        {
          selector: {
            container: '.jdgm-write-rev-link',
            item: ['']
          },
          section_name: 'write-review'
        },
        // jude me - see more
        {
          selector: {
            container: '.jdgm-gallery__thumbnail-link',
            item: ['']
          },
          section_name: 'jude-me-see-more'
        },
        // menu icon - mobile
        {
          selector: {
            container: '[data-menu-drawer]',
            item: ['']
          },
          section_name: 'menu-icon-mobile'
        },
        // search icon - mobile
        {
          selector: {
            container: "[data-drawer-options][href='/search']",
            item: ['']
          },
          section_name: 'search-icon-mobile'
        },
        // account icon - mobile
        {
          selector: {
            container: '.member-center',
            item: ['']
          },
          section_name: 'account-icon-mobile'
        },
        // cart icon - mobile
        {
          selector: {
            container: '.t4s-site-nav__cart',
            item: ['']
          },
          section_name: 'cart-icon-mobile'
        },
        // view all
        {
          selector: {
            container: '.t4s-viewall-btn',
            item: ['']
          },
          section_name: 'view-all'
        },
        // slideshow
        {
          selector: {
            container: '[class*="__slideshow_"]',
            item: ['.flickityt4s-viewport']
          },
          section_name: 'slideshow'
        },
        // new filter
        {
          selector: {
            container: '.product-categories',
            item: ['.category-item']
          },
          section_name: 'new-filter'
        },
        // mini cart - checkout
        {
          selector: {
            container: "[name='checkout'].t4s-btn__checkout",
            item: ['']
          },
          section_name: 'mini-cart-checkout'
        },
        // mini cart - quantity
        {
          selector: {
            container: '.t4s-mini_cart__info .t4s-quantity-cart-item',
            item: ['button']
          },
          section_name: 'mini-cart-quantity'
        },
        // mini cart - edit/remove
        {
          selector: {
            container: '.t4s-mini_cart__info .actions-box',
            item: ['a']
          },
          section_name: 'mini-cart-edit-or-remove'
        },
        // menus - mobile
        {
          selector: {
            container: '#menu-mb__ul',
            item: ['> li']
          },
          section_name: 'menus-mobile'
        },
        // firework-video
        {
          selector: {
            container: '#video-ab',
            item: ['']
          },
          section_name: 'firework-video'
        },
        // custom section
        {
          selector: {
            container: '[class*="__custom_section_"]',
            item: ['video', 'a', '.button', 'button', 'img']
          },
          section_name: 'custom-section'
        },
        // hero vedio
        {
          selector: {
            container: '.t4s-hero-video',
            item: ['video', 'a', '.button', 'button', 'img']
          },
          section_name: 'hero-video'
        },
        // image-scroll
        {
          selector: {
            container: '.t4s-image-scroll',
            item: ['a', '.button', 'button', 'img']
          },
          section_name: 'new-image-scroll'
        },
        // logo-list
        {
          selector: {
            container: '[class*="__logo_list_"]',
            item: ['.t4s-logo-item']
          },
          section_name: 'logo-list'
        },
        // product card
        {
          selector: {
            container: '[class*="__product_card_"]',
            item: ['a', '.button', 'img']
          },
          section_name: 'product-card'
        },
        // FAQ Section
        {
          selector: {
            container: '[class*="__faq_"]',
            item: ['.t4s-faq-question']
          },
          section_name: 'faq-section'
        },
        // ai page 埋点通用
        {
          selector: {
            container: '[class*="ogl-pre-page"]',
            item: ['video', 'a', '.button', 'button']
          },
          section_name: 'ogl-pre-page',
          actionType: ['click', 'impress']
        },
      ];

      // 为所有内置配置添加 configType: "batch"
      trackingConfig.forEach((config) => {
        config.configType = 'batch';
        config.trackingPriority = 10;
        config.trackingSource = 'default';
      });

      let individualTrackingData = []; // 保留全部 individual 规则，匹配后续新增节点
      const mutationHistory = new WeakMap();
      const pendingMutationScans = new Map();
      const SCAN_DELAY = 500;
      const BUSY_SCAN_DELAY = 1100;
      const BUSY_MUTATION_COUNT = 25;
      const MUTATION_IDLE_RESET = 30000;
      const MAX_PENDING_ROOTS = 128;
      let mutationScanTimer = null;
      let mutationScanDeadline = null;
      let impressObserver = null; // 曝光观察器
      const AUTO_TRACKING_BRIDGE_NAME = '__OGL_AUTO_TRACKING__';
      const elementIdIndex = new Map(); // element_id -> Set<HTMLElement>
      const registrySubscribers = new Set();
      let registryNotifyTimer = null;
      let resolveReadyPromise = null;
      const readyPromise = new Promise((resolve) => {
        resolveReadyPromise = resolve;
      });

      function getLiveElementsFromSet(elements) {
        return Array.from(elements || []).filter((element) =>
          document.documentElement.contains(element)
        );
      }

      function notifyRegistrySubscribers(reason) {
        if (registryNotifyTimer) return;

        registryNotifyTimer = setTimeout(() => {
          registryNotifyTimer = null;
          registrySubscribers.forEach((callback) => {
            try {
              callback({ reason });
            } catch (error) {
              window.report_faro({
                file_name: 'assets/auto-tracking.js',
                func_name: 'notifyRegistrySubscribers',
                desc: 'Auto-tracking registry subscriber failed',
                error: error
              });
            }
          });
        }, 0);
      }

      function getTrackingElementIds(element) {
        return new Set(
          [
            element.getAttribute('data-element-id'),
            element.getAttribute('data-click-element-id'),
            element.getAttribute('data-impress-element-id')
          ].filter(Boolean)
        );
      }

      function registerTrackedElement(element) {
        if (!element || !element.getAttribute) return;

        let changed = false;
        getTrackingElementIds(element).forEach((elementId) => {
          const currentElements = elementIdIndex.get(elementId) || new Set();
          if (!currentElements.has(element)) {
            currentElements.add(element);
            elementIdIndex.set(elementId, currentElements);
            changed = true;
          }
        });
        if (changed) notifyRegistrySubscribers('element-registered');
      }

      function unregisterTrackedElement(element) {
        if (!element || !element.getAttribute) return;

        let changed = false;
        getTrackingElementIds(element).forEach((elementId) => {
          const currentElements = elementIdIndex.get(elementId);
          if (!currentElements) return;
          changed = currentElements.delete(element) || changed;
          if (currentElements.size === 0) {
            elementIdIndex.delete(elementId);
          }
        });
        if (impressObserver) impressObserver.unobserve(element);
        if (changed) notifyRegistrySubscribers('element-unregistered');
      }

      // 保留通用属性供旧版圈选 UI 使用；采集按事件读取独立的 ID 和优先级。
      function getElementTrackingMeta(element, action) {
        const prefix = action ? `data-${action}-` : 'data-';
        if (action && !element.hasAttribute(`data-track-${action}`)) {
          return { elementId: null, trackingPriority: 0 };
        }
        const eventId = element.getAttribute(`${prefix}element-id`);
        return {
          elementId: eventId || element.getAttribute('data-element-id'),
          trackingPriority:
            Number(element.getAttribute(
              eventId ? `${prefix}tracking-priority` : 'data-tracking-priority'
            )) || 0
        };
      }

      function getClosestTrackingElementByPriority(element) {
        let currentElement =
          element && element.nodeType === Node.ELEMENT_NODE
            ? element
            : element?.parentElement || element?.parentNode;
        let matchedElement = null;
        let matchedPriority = -1;

        while (
          currentElement &&
          currentElement !== document &&
          currentElement.nodeType === Node.ELEMENT_NODE
        ) {
          if (currentElement.hasAttribute('data-track-click')) {
            const { elementId, trackingPriority } = getElementTrackingMeta(
              currentElement, 'click'
            );
            if (elementId && trackingPriority > matchedPriority) {
              matchedElement = currentElement;
              matchedPriority = trackingPriority;
            }
          }
          currentElement = currentElement.parentElement;
        }

        return matchedElement;
      }

      function unregisterTrackedSubtree(node) {
        if (!node || node.nodeType !== Node.ELEMENT_NODE) return;

        const element = node;
        unregisterTrackedElement(element);
        element
          .querySelectorAll('[data-element-id]')
          .forEach((child) => unregisterTrackedElement(child));
      }

      function markAutoTrackingReady() {
        const bridge = window[AUTO_TRACKING_BRIDGE_NAME];
        if (bridge) {
          bridge.ready = true;
        }
        document.body.setAttribute('data-tracking-ready', 'true');
        if (resolveReadyPromise) {
          resolveReadyPromise();
          resolveReadyPromise = null;
        }
        notifyRegistrySubscribers('ready');
      }

      function shouldIgnoreAutoTrackingNode(node) {
        if (!node || node.nodeType !== Node.ELEMENT_NODE) return true;

        const element = node;
        return Boolean(
          element.closest?.('[data-ogl-ignore-auto-tracking]') ||
          element.hasAttribute?.('data-ogl-ignore-auto-tracking') ||
          element.classList?.contains('rate-label') ||
          element.classList?.contains('rate-label-container') ||
          element.classList?.contains('stats-tooltip') ||
          element.classList?.contains('heatmap-canvas-overlay') ||
          element.classList?.contains('heatmap-hover-canvas-overlay') ||
          element.classList?.contains('heatmap-viewport-loading-overlay')
        );
      }

      function markTrackingElement($element, options) {
        const element = $element && $element[0];
        if (!element) return false;

        const {
          trackingId,
          elementId,
          elementSelector,
          actionType = ['click'],
          configType,
          trackingPriority = 10,
          trackingSource = 'default'
        } = options;

        const acceptedActions = ['click', 'impress'].filter((action) => {
          if (!actionType.includes(action)) return false;
          const currentMeta = getElementTrackingMeta(element, action);
          return (
            !currentMeta.elementId ||
            currentMeta.trackingPriority < trackingPriority
          );
        });
        if (!acceptedActions.length) {
          // 节点移除再插入时恢复索引和曝光观察，不重置曝光去重状态。
          registerTrackedElement(element);
          observeImpress(element);
          return false;
        }

        const currentMeta = getElementTrackingMeta(element);
        const previousImpressId = getElementTrackingMeta(
          element, 'impress'
        ).elementId;
        // 在更新通用属性前保存旧事件的 ID，兼容只有旧属性的元素。
        ['click', 'impress'].forEach((action) => {
          const meta = getElementTrackingMeta(element, action);
          if (meta.elementId && !element.hasAttribute(`data-${action}-element-id`)) {
            $element.attr(`data-${action}-element-id`, meta.elementId);
            $element.attr(
              `data-${action}-tracking-priority`, String(meta.trackingPriority)
            );
          }
        });
        unregisterTrackedElement(element);
        acceptedActions.forEach((action) => {
          $element.attr(`data-track-${action}`, 'true');
          $element.attr(`data-${action}-element-id`, elementId);
          $element.attr(`data-${action}-tracking-priority`, String(trackingPriority));
        });

        // 通用属性延续原来的优先级选择，不改变旧版 UI 的代表配置。
        if (!currentMeta.elementId || currentMeta.trackingPriority < trackingPriority) {
          $element.attr('data-tracking-id', trackingId);
          $element.attr('data-element-id', elementId);
          $element.attr('data-element-selector', elementSelector);
          $element.attr('data-tracking-priority', String(trackingPriority));
          $element.attr('data-tracking-source', trackingSource);
          if (configType) {
            $element.attr('data-config-type', configType);
          } else {
            $element.removeAttr('data-config-type');
          }
        }
        $element.addClass('tracking-setup-tracking-highlight');
        if (acceptedActions.includes('impress') && previousImpressId !== elementId) {
          $element.removeAttr('data-impress-sent');
        }
        registerTrackedElement(element);
        observeImpress(element);

        return true;
      }

      function isConfigInCurrentScope(scope) {
        return !scope
          ? true
          : /\/\*$/.test(scope || '')
            ? pathname.startsWith(scope?.replace('/*', '') || '/')
            : pathname === scope;
      }

      window[AUTO_TRACKING_BRIDGE_NAME] = {
        version: '1.0.0',
        ready: false,
        readyPromise,
        getElementsByElementId(elementId) {
          if (!elementId) return [];

          const currentElements = elementIdIndex.get(String(elementId));
          const liveElements = getLiveElementsFromSet(currentElements);
          if (currentElements && liveElements.length !== currentElements.size) {
            elementIdIndex.set(String(elementId), new Set(liveElements));
          }
          return liveElements;
        },
        getAllTrackedElements() {
          const trackedElements = [];
          elementIdIndex.forEach((elements) => {
            trackedElements.push(...getLiveElementsFromSet(elements));
          });
          return Array.from(new Set(trackedElements));
        },
        subscribe(callback) {
          if (typeof callback !== 'function') {
            return function noop() { };
          }

          registrySubscribers.add(callback);
          return function unsubscribe() {
            registrySubscribers.delete(callback);
          };
        }
      };

      const domain = window.ogl_api_base_url;

      if (!domain) {
        throw new Error('OGL API base URL is unavailable');
      }

      const platform = window.innerWidth > 768 ? 'pc' : 'mobile';
      const pathname = window.location.pathname;

      // 构造查询参数（将对象转换为 URLSearchParams）
      const queryParams = new URLSearchParams({
        current_page: 1,
        page_size: 10000,
        platform,
        pathname
      });

      function generateElementId({ baseId, element }) {
        const rawTagName =
          (element &&
            typeof element.prop === 'function' &&
            element.prop('tagName')) ||
          element?.tagName ||
          '';
        const tagName = rawTagName.toLowerCase();

        const normalizedBaseId = baseId || '';
        return tagName ? `${normalizedBaseId}_${tagName}` : normalizedBaseId;
      }

      function getT() {
        return fetch(`${domain}/api/v1/login`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            user_name: 'buried_point',
            user_password: 'CQmw852Vzw62zhwHwYaX'
          })
        })
          .then((res) => res.json())
          .then((res) => res.data.token)
          .catch((error) => {
            window.report_faro({
              file_name: 'assets/auto-tracking.js',
              func_name: 'getT',
              desc: 'Failed to fetch the authentication token',
              error: error
            });
          });
      }

      // 初始化曝光观察器
      function initImpressObserver() {
        if (!impressObserver) {
          impressObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  const element = entry.target;
                  // 检查是否已经曝光过
                  if (
                    element.dataset.impressSent ||
                    !document.documentElement.contains(element)
                  ) return;

                  const { elementId } = getElementTrackingMeta(element, 'impress');
                  if (elementId) {
                    // 发布曝光事件
                    Shopify.analytics.publish('auto_tracking', {
                      type: 'impress',
                      element_id: elementId,
                      platform,
                      customerId: window.customer_id || '',
                      pathname,
                      text: element.innerText?.slice(0, 100) || ''
                    });
                    // 标记已曝光
                    element.dataset.impressSent = 'true';
                    // 取消观察
                    impressObserver.unobserve(element);
                  }
                }
              });
            },
            { threshold: 0 }
          ); // 进入视口时触发
        }
      }

      // 将元素添加到曝光观察器
      function observeImpress(element) {
        if (
          element && element.dataset.trackImpress &&
          !element.dataset.impressSent && impressObserver
        ) {
          impressObserver.observe(element);
        }
      }

      // 给元素添加标识并返回处理失败的数据（individual 模式）
      function addMarks(trackingData, isInScope) {
        if (!trackingData || !trackingData.length || !window.$) return [];

        const filteredData = trackingData.filter((item) =>
          isConfigInCurrentScope(item.scope)
        );

        const successfullyProcessed = [];
        const failedToProcess = [];

        // 遍历数据，查找并添加标识
        filteredData.forEach((item) => {
          try {
            // 跳过 selector 为空或无效的数据
            if (!item.selector || item.selector.trim() === '') {
              window.report_faro({
                file_name: 'assets/auto-tracking.js',
                func_name: 'addMarks',
                desc: 'Skipped data with an empty selector',
                error: JSON.stringify(item)
              });
              return;
            }

            // 跳过 batch 类型的数据（应该由 autoMarks 处理）
            if (item.params) {
              try {
                const params = JSON.parse(item.params);
                if (params.configType === 'batch') {
                  return;
                }
              } catch (e) {
                // JSON 解析失败，继续处理
              }
            }

            let foundElements = [];

            // 直接使用 jQuery
            try {
              const jqueryResult = $(item.selector);
              foundElements = Array.from(jqueryResult).filter(
                (element) => !isInScope || isInScope(element)
              );
            } catch (jqueryError) {
              window.report_faro({
                file_name: 'assets/auto-tracking.js',
                func_name: 'addMarks',
                desc: `jQuery selector query failed: ${item.selector}`,
                error: jqueryError
              });
              foundElements = [];
            }

            if (foundElements.length === 0) {
              // 没找到元素，记录为处理失败
              failedToProcess.push(item);
              return;
            }

            // 解析 actionType（individual 模式默认为 click）
            let actionType = ['click'];
            if (item.params) {
              try {
                const params = JSON.parse(item.params);
                if (params.actionType && Array.isArray(params.actionType)) {
                  actionType = params.actionType;
                }
              } catch (e) {
                // JSON 解析失败，使用默认值
              }
            }

            // 为找到的元素添加数据属性，便于识别
            foundElements.forEach((el) => {
              markTrackingElement($(el), {
                trackingId: item.id || '',
                elementId: item.element_id || '',
                elementSelector: item.selector || '',
                actionType,
                trackingPriority: 30,
                trackingSource: 'server-individual'
              });
            });

            // 记录为成功处理
            successfullyProcessed.push(item);
          } catch (error) {
            window.report_faro({
              file_name: 'assets/auto-tracking.js',
              func_name: 'addMarks',
              desc: `Failed to add tracking attributes: ${item.selector}`,
              error: error
            });
            failedToProcess.push(item);
          }
        });


        // 返回处理失败的数据，这些数据需要在下次重新尝试处理
        return failedToProcess;
      }

      // 渲染服务端的埋点配置
      function renderServerTrackingConfig() {
        // 发起 fetch 请求
        getT().then(function (T) {
          // 如果当前页面处在 iframe 中，无需初始化埋点标识
          if (window !== window.top) return;

          // 添加请求头
          const headers = new Headers();
          headers.append('token', T);

          fetch(
            `${domain}/api/v1/buried-point/list-paging?${queryParams.toString()}&site_id=${window.ogl_config.site?.id
            }`,
            {
              method: 'GET',
              headers: headers
            }
          )
            .then((response) => {
              return response.json(); // 解析 JSON 响应
            })
            .then((data) => {
              const trackingData = data?.data?.total_list || [];

              // 分离 individual 和 batch 模式的数据
              const individualData = [];
              const batchConfigs = [];

              trackingData.forEach((item) => {
                if (item.params) {
                  try {
                    const params = JSON.parse(item.params);
                    // batch 模式必须有 container 和 item
                    if (
                      params.configType === 'batch' &&
                      params.container &&
                      params.item
                    ) {
                      // batch 模式，转换为配置格式
                      // 从 params 中提取 section_name，如果没有则使用 item.element_id 作为备用
                      batchConfigs.push({
                        section_name:
                          params.section_name ||
                          item.element_id ||
                          `batch-${item.id}`,
                        selector: {
                          container: params.container,
                          item: params.item
                        },
                        actionType: params.actionType || ['click'],
                        scope: item.scope,
                        configType: 'batch',
                        trackingPriority: 20,
                        trackingSource: 'server-batch'
                      });
                    } else {
                      // individual 模式
                      individualData.push(item);
                    }
                  } catch (e) {
                    // JSON 解析失败，按 individual 模式处理
                    individualData.push(item);
                  }
                } else {
                  // 没有 params，按 individual 模式处理
                  individualData.push(item);
                }
              });


              // 处理 individual 模式数据
              individualTrackingData = individualData;
              addMarks(individualTrackingData);

              // 处理 batch 模式配置
              if (batchConfigs.length > 0) {
                // 将 batch 配置添加到 trackingConfig，使用统一的处理逻辑
                batchConfigs.forEach((config) => {
                  trackingConfig.push(config);
                });
                // 重新执行 autoMarks 处理新增的配置
                autoMarks();
              }
            })
            .catch((error) => {
              window.report_faro({
                file_name: 'assets/auto-tracking.js',
                func_name: 'renderServerTrackingConfig',
                desc: 'Failed to fetch server tracking configuration',
                error: error
              });
              // 在这里处理错误
            });
        });
      }

      function autoMarks(targetRoots, isInScope) {
        if (!window.$) {
          window.report_faro({
            file_name: 'assets/auto-tracking.js',
            func_name: 'autoMarks',
            desc: 'Unable to run autoMarks because jQuery is not loaded',
            error: 'window.$ is unavailable'
          });
          return;
        }

        const scopedRoots = Array.isArray(targetRoots)
          ? targetRoots.filter(
            (root) =>
              root &&
              root.nodeType === Node.ELEMENT_NODE &&
              document.documentElement.contains(root)
          )
          : [];
        const isLocalScan = Array.isArray(targetRoots);
        if (isLocalScan && !scopedRoots.length) return;
        if (isLocalScan && !isInScope) isInScope = createScanScope(scopedRoots);

        trackingConfig.forEach((config, configIndex) => {
          try {
            const {
              selector,
              section_name,
              actionType = ['click'],
              configType,
              scope,
              trackingPriority = 10,
              trackingSource = 'default'
            } = config;

            if (!selector || !selector.container) {
              // console.warn(`配置 ${configIndex} 缺少必要的 selector.container`);
              return;
            }

            if (!isConfigInCurrentScope(scope)) {
              return;
            }

            // 确保 container 选择器包含 :visible
            let containerSelector = selector.container;
            if (!containerSelector.includes(':visible')) {
              // 如果没有 :visible，添加到选择器末尾（在任何 :eq() 之前）
              containerSelector = containerSelector.replace(
                /(:eq\(\d+\).*)?$/,
                ':visible$1'
              );
            }

            // 序号必须来自全页匹配集合，不能用局部容器下标生成旧格式 ID。
            const $containers = $(containerSelector);

            if ($containers.length === 0) {
              return;
            }

            // 使用配置中的 section_name，如果没有则使用 'unknown'
            const sectionName = section_name || 'unknown';
            // 统一使用 auto-config-{configIndex} 作为 tracking-id
            const trackingId = `auto-config-${configIndex}`;

            $containers.each(function (containerIndex) {
              // 新节点可能位于已有容器内，也可能自身包含新容器。
              if (isLocalScan && !isInScope(this)) return;
              const $container = $(this);

              // 处理 item 数组
              if (!selector.item || !Array.isArray(selector.item)) {
                // console.warn(`配置 ${configIndex}: selector.item 必须是数组`);
                return;
              }

              // 如果 item 是空数组或只有空字符串，直接给容器添加标识
              if (selector.item.length === 0 || selector.item[0] === '') {
                const autoGeneratedElementId = `eq${containerIndex}_${sectionName}_container`;
                const generatedElementId = generateElementId({
                  baseId: autoGeneratedElementId,
                  element: $container
                });

                // 构建完整的 selector（包含 :visible 和 :eq()）
                const fullSelector = `${containerSelector}:eq(${containerIndex})`;

                markTrackingElement($container, {
                  trackingId,
                  elementId: generatedElementId,
                  elementSelector: fullSelector,
                  actionType,
                  configType,
                  trackingPriority,
                  trackingSource
                });
              } else {
                // 遍历 item 选择器数组
                selector.item.forEach((itemSelector) => {
                  if (!itemSelector) return;

                  // 在容器内查找 item 元素
                  const $items = $container.find(itemSelector);

                  if ($items.length === 0) {
                    return;
                  }

                  $items.each(function (itemIndex) {
                    if (isLocalScan && !isInScope(this)) return;
                    const $item = $(this);

                    // 生成 element_id: eq{containerIndex}_{section_name}_{itemIndex}
                    const autoGeneratedElementId = `eq${containerIndex}_${sectionName}_${itemIndex}`;
                    const generatedElementId = generateElementId({
                      baseId: autoGeneratedElementId,
                      element: $item
                    });

                    // 构建完整的 selector（container:visible:eq(n) + item:visible:eq(n)）
                    const fullSelector = `${containerSelector}:eq(${containerIndex}) ${itemSelector}:visible:eq(${itemIndex})`;

                    markTrackingElement($item, {
                      trackingId,
                      elementId: generatedElementId,
                      elementSelector: fullSelector,
                      actionType,
                      configType,
                      trackingPriority,
                      trackingSource
                    });
                  });
                });
              }
            });
          } catch (error) {
            window.report_faro({
              file_name: 'assets/auto-tracking.js',
              func_name: 'autoMarks',
              desc: `Failed to process tracking configuration ${configIndex}`,
              error: error
            });
          }
        });

      }

      // 预先索引祖先，避免大量新增根与每个候选元素做两两比较。
      function createScanScope(roots) {
        const rootSet = new Set(roots);
        const ancestors = new WeakSet();
        roots.forEach((root) => {
          let current = root.parentElement;
          while (current && !ancestors.has(current)) {
            ancestors.add(current);
            current = current.parentElement;
          }
        });
        return (element) => {
          if (ancestors.has(element)) return true;
          let current = element;
          while (current) {
            if (rootSet.has(current)) return true;
            current = current.parentElement;
          }
          return false;
        };
      }

      function addPendingRoot(roots, node, parent) {
        if (roots.has(parent)) return;
        if (node === parent || roots.size >= MAX_PENDING_ROOTS) {
          roots.clear();
          roots.add(parent);
        } else {
          roots.add(node);
        }
      }

      function armMutationScanTimer() {
        let deadline = Infinity;
        pendingMutationScans.forEach((state) => {
          deadline = Math.min(deadline, state.deadline);
        });
        if (deadline === Infinity) {
          if (mutationScanTimer !== null) clearTimeout(mutationScanTimer);
          mutationScanTimer = null;
          mutationScanDeadline = null;
          return;
        }
        if (mutationScanTimer !== null && mutationScanDeadline <= deadline)
          return;
        if (mutationScanTimer !== null) clearTimeout(mutationScanTimer);
        mutationScanDeadline = deadline;
        mutationScanTimer = setTimeout(
          flushMutationScans,
          Math.max(0, deadline - performance.now())
        );
      }

      function flushMutationScans() {
        mutationScanTimer = null;
        mutationScanDeadline = null;
        const now = performance.now();
        const roots = new Set();
        pendingMutationScans.forEach((state, parent) => {
          if (state.deadline > now) return;
          pendingMutationScans.delete(parent);
          state.roots.forEach((root) => {
            if (
              document.documentElement.contains(root) &&
              !shouldIgnoreAutoTrackingNode(root)
            )
              roots.add(root);
          });
        });
        try {
          if (roots.size) {
            const scanRoots = Array.from(roots);
            const isInScope = createScanScope(scanRoots);
            if (individualTrackingData.length)
              addMarks(individualTrackingData, isInScope);
            autoMarks(scanRoots, isInScope);
          }
        } finally {
          armMutationScanTimer();
        }
      }

      function queueMutationScans(changes) {
        if (!changes.size) return;
        const now = performance.now();
        changes.forEach((roots, parent) => {
          let history = mutationHistory.get(parent);
          if (!history || now - history.lastMutation >= MUTATION_IDLE_RESET) {
            history = { count: 0, lastMutation: now };
            mutationHistory.set(parent, history);
          }
          history.count = Math.min(history.count + 1, BUSY_MUTATION_COUNT);
          history.lastMutation = now;
          let pending = pendingMutationScans.get(parent);
          if (!pending) {
            pending = {
              deadline:
                now +
                (history.count >= BUSY_MUTATION_COUNT
                  ? BUSY_SCAN_DELAY
                  : SCAN_DELAY),
              roots: new Set()
            };
            pendingMutationScans.set(parent, pending);
          }
          roots.forEach((root) => addPendingRoot(pending.roots, root, parent));
        });
        armMutationScanTimer();
      }

      // 仅识别倒计时根节点自身的等结构数字替换，不能忽略整个后代区域。
      function isCountdownDisplayMutation(mutation) {
        if (mutation.type !== 'childList' ||
          !mutation.target.matches('[data-countdown-t4s]') ||
          !mutation.addedNodes.length || !mutation.removedNodes.length) return false;
        const signature = (nodes) => {
          const parts = [];
          let hasDigits = false;
          let visited = 0;
          const inspect = (node) => {
            // 大型或异常组件不做昂贵的过滤分析，回退正常节流扫描。
            if (++visited > 256) return false;
            if (node.nodeType === Node.TEXT_NODE) {
              const text = node.textContent.trim();
              if (!text) return true;
              if (text.length > 128) return false;
              // 未识别的文案和业务内容一律回到正常扫描，宁可少过滤。
              const unit = text.replace(/[0-9\s:.,+−–-]/g, '');
              if (unit && !/^(days?|hours?|minutes?|mins?|seconds?|secs?|d|h|m|s)$/i.test(unit)) return false;
              hasDigits = hasDigits || /[0-9]/.test(text);
              parts.push(['text', text.replace(/[0-9]+/g, '#')]);
              return true;
            }
            if (node.nodeType !== Node.ELEMENT_NODE ||
              !/^(SPAN|B|STRONG|EM|I|SMALL|DIV|BR)$/.test(node.tagName) ||
              node.matches('[role], [tabindex], [contenteditable], [onclick], [data-countdown-t4s], [data-element-id], [data-track-click], [data-track-impress]')) return false;
            if (node.attributes.length > 16 || Array.from(node.attributes).some((attr) => attr.value.length > 256)) return false;
            parts.push(['element', node.tagName, Array.from(node.attributes, (attr) => [attr.name, attr.value]).sort()]);
            return true;
          };
          for (const node of nodes) {
            if (!inspect(node)) return null;
            // 显式栈保存层级，避免递归深度限制，且签名不会混淆不同结构。
            const stack = [];
            if (node.nodeType === Node.ELEMENT_NODE) stack.push({ node: node.firstChild });
            while (stack.length) {
              const frame = stack[stack.length - 1];
              if (!frame.node) {
                parts.push(['end']);
                stack.pop();
                continue;
              }
              const child = frame.node;
              frame.node = child.nextSibling;
              if (!inspect(child)) return null;
              if (child.nodeType === Node.ELEMENT_NODE) stack.push({ node: child.firstChild });
            }
          }
          return hasDigits ? JSON.stringify(parts) : null;
        };
        const before = signature(mutation.removedNodes);
        return before !== null && before === signature(mutation.addedNodes);
      }

      const observer = new MutationObserver((mutations) => {
        const changes = new Map();
        const record = (parent, root) => {
          let roots = changes.get(parent);
          if (!roots) changes.set(parent, (roots = new Set()));
          addPendingRoot(roots, root, parent);
        };
        mutations.forEach((mutation) => {
          const parent = mutation.target;
          if (shouldIgnoreAutoTrackingNode(parent)) return;

          // 无论是否过滤倒计时，移除的埋点都必须清理；同批移动保留。
          if (mutation.type === 'childList') {
            mutation.removedNodes.forEach((node) => {
              if (!document.documentElement.contains(node))
                unregisterTrackedSubtree(node);
            });
          }
          if (isCountdownDisplayMutation(mutation)) {
            // 过滤数字替换不能丢掉尚未完成的首次扫描。迁移到稳定根，
            // 保持原截止时间和计数；无待处理任务时不创建新扫描。
            const pending = pendingMutationScans.get(parent);
            if (pending) addPendingRoot(pending.roots, parent, parent);
            const currentRoots = changes.get(parent);
            if (currentRoots) addPendingRoot(currentRoots, parent, parent);
            return;
          }

          if (mutation.type === 'attributes') {
            const becameVisible =
              (mutation.attributeName === 'aria-hidden' &&
                parent.getAttribute('aria-hidden') === 'false') ||
              (mutation.attributeName === 'style' &&
                parent.style.display === 'block');
            if (becameVisible) record(parent, parent);
            return;
          }
          mutation.addedNodes.forEach((node) => {
            if (shouldIgnoreAutoTrackingNode(node)) return;
            // 同批追加又替换的旧节点也先记录，后续过滤可迁移任务。
            record(parent, node);
            if (!document.documentElement.contains(node)) return;
            // 恢复已标记节点不必等待节流；新节点交给到期扫描处理。
            const restore = (element) => {
              if (shouldIgnoreAutoTrackingNode(element)) return;
              registerTrackedElement(element);
              observeImpress(element);
            };
            if (node.hasAttribute('data-element-id')) restore(node);
            node.querySelectorAll('[data-element-id]').forEach(restore);
          });
        });
        queueMutationScans(changes);
      });

      // 开始观察 body 的变化 - 只监听子节点添加和特定属性变化
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-hidden', 'style'] // 只监听需要的属性，提升性能
      });

      // 给元素添加事件绑定，找到距离目标元素最近的父级元素
      document.addEventListener(
        'click',
        function (event) {
          // 首先判断是否为真实的用户点击事件
          if (!event.isTrusted) {
            return;
          }

          // 1. 获取当前点击的元素
          const currentElement = event.target;
          const trackingElement =
            getClosestTrackingElementByPriority(currentElement);

          // 检查是否需要统计点击
          if (!trackingElement || !trackingElement.dataset.trackClick) {
            return;
          }

          const text = trackingElement?.innerText?.slice(0, 100) || '';
          const { elementId } = getElementTrackingMeta(trackingElement, 'click');

          // 2. 发送埋点
          if (elementId) {
            Shopify.analytics.publish('auto_tracking', {
              type: 'click',
              element_id: elementId,
              platform,
              customerId: window.customer_id || '',
              pathname,
              text
            });
          }
        },
        true
      );

      // 初始化内置埋点配置
      if (document.readyState === 'loading') {
        // DOM 还在加载中，等待 DOMContentLoaded
        document.addEventListener('DOMContentLoaded', function () {
          initImpressObserver(); // 初始化曝光观察器
          autoMarks();
          renderServerTrackingConfig();

          // 设置埋点已准备好
          markAutoTrackingReady();
        });
      } else {
        // DOM 已经加载完成，直接执行
        initImpressObserver(); // 初始化曝光观察器
        autoMarks();
        renderServerTrackingConfig();
        // 设置埋点已准备好
        markAutoTrackingReady();
      }

      // ========== 停留时间和浏览深度统计 ==========
      let pageEnterTime = Date.now(); // 记录页面进入时间
      let maxScrollDepth = 1; // 记录最大浏览深度（屏数），默认为1
      let scrollDepthDebounceTimer = null; // 滚动防抖定时器
      let statisticsSent = false; // 防止重复发送统计数据

      // 计算当前浏览深度（屏数），使用 Math.floor 向下取整
      function calculateScrollDepth() {
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        const viewportHeight = window.innerHeight;
        // scrollTop=0时，depth=0，返回1（第一屏）
        // scrollTop>=viewportHeight时，depth>=1，返回2（第二屏）
        const depth = Math.floor(scrollTop / viewportHeight);
        return depth + 1;
      }

      // 防抖的滚动事件处理
      function debouncedScrollHandler() {
        if (scrollDepthDebounceTimer) {
          clearTimeout(scrollDepthDebounceTimer);
        }

        scrollDepthDebounceTimer = setTimeout(() => {
          const currentDepth = calculateScrollDepth();

          // 如果浏览深度增加，更新最大浏览深度
          if (currentDepth > maxScrollDepth) {
            maxScrollDepth = currentDepth;
          }
        }, 100); // 100ms 防抖
      }

      // 监听滚动事件，统计浏览深度
      window.addEventListener('scroll', debouncedScrollHandler, {
        passive: true
      });

      // 页面离开时发送停留时间和浏览深度统计
      function sendPageStatistics() {
        // 防止重复发送
        if (statisticsSent) {
          return;
        }
        statisticsSent = true;

        const pageLeaveTime = Date.now();
        const duration = pageLeaveTime - pageEnterTime; // 停留时间（毫秒）


        // 如果停留时间大于1天，只记录为1天的毫秒数
        const ONE_DAY_MS = 24 * 60 * 60 * 1000;
        const reportedDuration = duration > ONE_DAY_MS ? ONE_DAY_MS : duration;

        Shopify.analytics.publish('auto_tracking', {
          type: 'page_statistics',
          platform,
          customerId: window.customer_id || '',
          pathname,
          duration: reportedDuration, // 停留时间（毫秒）
          scroll_depth: maxScrollDepth // 浏览深度（屏数）
        });
      }

      // 监听页面离开事件
      // 使用 visibilitychange 处理页面切换和标签页隐藏
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') {
          sendPageStatistics();
        }
      });

      // 使用 pagehide 处理页面卸载（包括关闭、刷新、导航等）
      window.addEventListener('pagehide', function () {
        sendPageStatistics();
      });

      // ========== 停留时间和浏览深度统计结束 ==========
    } catch (error) {
      window.report_faro({
        file_name: 'assets/auto-tracking.js',
        func_name: 'autoTrackingInit',
        desc: 'Auto-tracking initialization failed',
        error: error
      });
    }
  })();

  // 商品详情页特殊上报逻辑整合
  (function () {
    if (!document.body.classList.contains('template-product')) {
      return
    }
    function trackVideoPlayStart(product) {
      var video = document.getElementById('size_guide_video-player');
      const product_type = product.type || '';
      const video_map = window.size_guide_video_map || {};
      video.src = video_map[product_type]?.video || '';
      var timeupdateTracked = false;
      var playTracked = false;
      if (video) {
        video.addEventListener('play', function () {
          if (playTracked) return;
          Shopify.analytics.publish('auto_tracking', {
            type: 'video-play-start'
          });
          playTracked = true;
        });
        video.addEventListener('timeupdate', function () {
          if (!timeupdateTracked && this.currentTime >= 3) {
            Shopify.analytics.publish('auto_tracking', {
              type: 'video-play-3s'
            });
            timeupdateTracked = true;
          }
        });
        video.addEventListener('ended', function () {
          Shopify.analytics.publish('auto_tracking', {
            type: 'video-play-complete'
          });
        });
      }
    }

    function trackVideoIntersection() {
      // 2. 获取所有需要监听的元素
      const mediaItems = document.querySelectorAll('.t4s-product__media-item');

      // 3. 配置 IntersectionObserver 的参数 (可选)
      // const options = {
      //   root: null,       // 监听元素的祖先节点，null 表示默认使用浏览器视口 (viewport)
      //   rootMargin: '0px',// 视口的边距，可以用来提前或延迟触发 (例如 '50px' 表示提前 50px 触发)
      //   threshold: 0.5    // 触发的阈值，0.1 表示元素有 10% 进入视口时就会触发回调
      // };

      // let observedNum = 0

      // // 4. 创建观察者实例
      // const observer = new IntersectionObserver((entries, observer) => {
      //   entries.forEach(entry => {
      //     // isIntersecting 属性为 true 表示元素当前在视口中可见
      //     if (entry.isIntersecting) {
      //       const source = entry.target.querySelector('video source')?.src || entry.target.dataset.imgSrc || ""
      //       const index = entry.target.dataset.index || 0
      //       const type = entry.target.dataset.mediaType || ""
      //       if (observedNum == 2) {
      //         Shopify.analytics.publish("product_media", {
      //           type: "three_impressions",
      //           product_id: meta.product.id,
      //           media_index: index,
      //           media_name: source,
      //           media_type: type
      //         });
      //         observer.disconnect()
      //       }
      //       observedNum += 1
      //     } else {
      //       // 元素离开视口，不可见
      //     }
      //   });
      // }, options);

      // 5. 遍历获取到的元素，并让观察者开始监听它们
      if (mediaItems.length > 0) {
        mediaItems.forEach((item) => {
          // observer.observe(item)
          item.addEventListener('click', function (e) {
            const source =
              e.currentTarget.querySelector('video source')?.src ||
              e.currentTarget.dataset.imgSrc ||
              '';
            const index = e.currentTarget.dataset.index || 0;
            const type = e.currentTarget.dataset.mediaType || '';
            Shopify.analytics.publish('product_media', {
              type: 'click',
              product_id: meta.product.id,
              media_index: index,
              media_name: source,
              media_type: type
            });
          });
        });
      } else {
        window.report_faro({
          file_name: 'assets/auto-tracking.js',
          func_name: 'trackVideoIntersection',
          desc: 'No product media elements found',
          error: 'Missing elements: .t4s-product__media-item'
        });
      }
    }

    function initTrackPdpClickEvent(e) {

      function sendPdpData(info) {
        const click_type = info.type

        Shopify.analytics.publish("product_interest_click", {
          type: click_type,
          text: info.text
        });
      }

      function review_click(e) {
        if (document.querySelector('#judgeme_product_reviews')?.contains(e.target)) {
          sendPdpData({
            type: 'click_prd_customer_review'
          })
        }
      }

      function pdp_ele_click(e) {
        const pdp_click_type = e.currentTarget.dataset.pdpClick
        const pdp_click_text = e.currentTarget.dataset.pdpClick_text

        sendPdpData({
          type: pdp_click_type,
          text: pdp_click_text
        })
      }

      document.addEventListener('click', review_click, true)

      // firework点击
      document.addEventListener('fw:embed-feed:thumbnail-click', function (event) {
        sendPdpData({
          type: 'click_prd_product_egc'
        })
      });

      const pdp_click_eles = document.querySelectorAll('[data-pdp-click]')
      pdp_click_eles.forEach((ele) => {
        ele.addEventListener('click', pdp_ele_click, true)
      })
    }

    initTrackPdpClickEvent()

    document.addEventListener('DOMContentLoaded', function () {
      if (meta?.product) {
        trackVideoPlayStart(meta.product);
        trackVideoIntersection();
      }
    });

  })();
})();
